export default "__VITE_ASSET__c17289b4__"